// Super Simple Formatter
// Just clean text and make bullet points - no fancy formatting

class SimpleFormatter {
  // Clean text and remove markdown mess
  static cleanText(text) {
    if (!text) return '';

    return text
      .replace(/\*+/g, '') // Remove all asterisks
      .replace(/_+/g, '') // Remove all underscores
      .replace(/#+/g, '') // Remove hash symbols
      .replace(/\s+/g, ' ') // Clean up whitespace
      .trim();
  }

  // Split text into simple bullet points
  static formatAsBullets(text) {
    if (!text) return '';

    const cleanText = this.cleanText(text);

    // Split by common separators
    const sentences = cleanText
      .split(/[.!?]+/)
      .map(s => s.trim())
      .filter(s => s.length > 10); // Only meaningful sentences

    if (sentences.length <= 1) {
      return `<div class="text-gray-700 leading-relaxed">${cleanText}</div>`;
    }

    return `
      <div class="space-y-2">
        ${sentences.map(sentence => `
          <div class="flex items-start">
            <span class="text-blue-500 mr-2">•</span>
            <span class="text-gray-700">${sentence}</span>
          </div>
        `).join('')}
      </div>
    `;
  }

  // Just display as simple paragraphs
  static formatAsText(text) {
    if (!text) return '';

    const cleanText = this.cleanText(text);

    // Split into paragraphs by line breaks
    const paragraphs = cleanText
      .split(/\n+/)
      .map(p => p.trim())
      .filter(p => p.length > 0);

    return paragraphs
      .map(p => `<p class="mb-3 text-gray-700 leading-relaxed">${p}</p>`)
      .join('');
  }

  // Split by common patterns and make simple list
  static formatAsList(text) {
    if (!text) return '';

    const cleanText = this.cleanText(text);

    // Look for lines that start with dashes (common in AI output)
    const lines = cleanText.split('\n').filter(line => line.trim().length > 0);
    const items = [];

    lines.forEach(line => {
      const trimmed = line.trim();
      if (trimmed.startsWith('-') || trimmed.startsWith('•')) {
        // Remove the dash/bullet and add the content
        items.push(trimmed.replace(/^[-•]\s*/, ''));
      } else if (trimmed.length > 5) {
        // Add non-bullet lines as items too
        items.push(trimmed);
      }
    });

    if (items.length <= 1) {
      return this.formatAsText(cleanText);
    }

    return `
      <div class="space-y-3">
        ${items.map(item => `
          <div class="flex items-start">
            <span class="text-blue-500 mr-3 text-sm font-bold">•</span>
            <span class="text-gray-700 text-sm leading-relaxed">${item}</span>
          </div>
        `).join('')}
      </div>
    `;
  }
}

export default SimpleFormatter;